import styled from 'styled-components';
import { theme } from '../../../../../theme';

const { colors } = theme;

export const DivTotalCount = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
`;

export const SpanAllDirectories = styled.span`
  margin-right: 0.8rem;
`;

export const SpanTotalCount = styled.span`
  color: ${colors.textDeaccent};
`;
